export const action = (startType, successType, failType) => {
  const start = () => ({ type: startType });
  const success = (data) => ({
    type: successType,
    payload: data
  });
  const fail = (message) => ({
    type: failType,
    payload: message
  });

  return { start, success, fail };
};
